// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".c05f6d57f49aabe2dadce8a91b83c376071f0382.chunk.js";
};